import { theme, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { screenshotsGet, screenshotsState } from '../../reports/screenshots/screenshots.slice'
import { useDispatch, useSelector } from 'react-redux'
import { ScreenShotComponent } from '../../reports/screenshots/ScreenShotComponent'

const ScreenShotList = ({ user }) => {
    const { Text } = Typography
    const dispatch = useDispatch()

    const { useToken } = theme

    const { token } = useToken()

    const { screenshotsData, status, userChangeName } =
        useSelector(screenshotsState)

    const { reportDrawerFilterData, userTaskLogs, userReportsTaskLogLoading } = useSelector((state) => state.finalReportsSlice)
    const [page, setPage] = useState(0)
    async function DateRangeSet(pageNo = 0) {
        if (reportDrawerFilterData?.start && reportDrawerFilterData?.end) {
            const { projectId, ...rest } = reportDrawerFilterData;

            // Extract first project ID from array of objects
            // const validProjectId =
            //     Array.isArray(projectId) &&
            //         projectId.length > 0 &&
            //         typeof projectId[0]?.value === 'string' &&
            //         projectId[0]?.value.trim()
            //         ? projectId[0].value
            //         : null;

            const validProjectId = Array.isArray(projectId) && projectId.length > 0 ? projectId.map((e) => e?.value) : [];
            const dataScreen = {
                start: reportDrawerFilterData.start,
                end: reportDrawerFilterData.end,
                projectId: validProjectId,
                userId: user?._id,
                assigneeId: [user?._id],
                limit: 10,
                skip: pageNo * 10,
            };
            dispatch(screenshotsGet(dataScreen));
        }
    }


    useEffect(() => {
        setPage(0)
        DateRangeSet(0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportDrawerFilterData.projectId, reportDrawerFilterData.end, reportDrawerFilterData.start])

    const loadNextPage = () => {
        if (screenshotsData?.isNext) {
            const nextPage = page + 1
            setPage(nextPage)
            DateRangeSet(nextPage)
        }
    }
    return (
        <div
            id="scrollableDiv"
            style={{
                height: 'calc(100vh - 200px)', // adjust as per layout
                overflow: 'auto',
                padding: '0px 0px 0px 24px',
            }}
        >
            <ScreenShotComponent
                screenshotsData={screenshotsData}
                token={token}
                loading={status !== "loaded"}
                onLoadMore={loadNextPage}
            />
        </div>
    )
}

export default ScreenShotList
